import React from 'react';
import { Table, Tag, Tooltip, Icon } from 'antd';
import { UrlCluster, UrlClusterTableRecord } from './types';
import UrlClustersMonitoredUrlsCell from './UrlClustersMonitoredUrlsCell';
import './UrlClusters.less';


const { Column } = Table;
type Props = {
    clusters: UrlCluster[];
};


function getUrlClustersTableData(clusters: UrlCluster[]): UrlClusterTableRecord[] {
    return clusters.map((cluster, idx) => ({
        key: cluster.guid,
        idx: idx + 1,
        guid: cluster.guid,
        title: cluster.title,
        description: cluster.description,
        pueLevel: cluster.pue_level,
        pueReason: cluster.pue_reason,
        monitoredUrls: cluster.monitored_urls
    }));
}

function transformPueLevel(pueLevel: string): string {
    switch (pueLevel) {
        case 'very_low':
            return 'Very Low';
        case 'low':
            return 'Low';
        case 'medium':
            return 'Medium';
        case 'high':
            return 'High';
        case 'very_high':
            return 'Very High';
        default:
            return pueLevel;
    }
}

function getPueLevelColor(pueLevel: string): string {
    switch (pueLevel) {
        case 'very_low':
            return 'red';
        case 'low':
            return 'volcano';
        case 'medium':
            return 'orange';
        case 'high':
            return 'cyan';
        case 'very_high':
            return 'green';
        default:
            return 'default';
    }
}

export default function UrlClustersTable({ clusters }: Props) {
    return (
        <Table
            className="url-clusters-table"
            pagination={false}
            size="small"
            dataSource={getUrlClustersTableData(clusters)}
        >
            <Column
                key="label"
                title="Group Title"
                className="al-left"
                render={(text, record: UrlClusterTableRecord) => (
                    <div className="cluster-container">
                        <div className="cluster-title">{record.title}</div>
                        <div className="cluster-description">{record.description}</div>
                    </div>
                )}
            />
            <Column
                key="pueLevel"
                title="Potential User Engagement"
                className="al-center"
                width={275}
                render={(text, record: UrlClusterTableRecord) => (
                    <>
                        <Tag className="pue-level" color={getPueLevelColor(record.pueLevel)}>{transformPueLevel(record.pueLevel)}</Tag>
                        <Tooltip title={record.pueReason}>
                            <Icon className="pue-reason-icon" type="info-circle" theme="filled" />
                        </Tooltip>
                    </>
                )}
            />
            <Column
                className="al-right no-wrap"
                title="Monitored URLs"
                width={175}
                render={(text, record: UrlClusterTableRecord) => (
                    <UrlClustersMonitoredUrlsCell
                        monitoredUrls={record.monitoredUrls}
                        clusterGuid={record.guid}
                    />
                )}
            />
        </Table>
    );
}
